import React from 'react';
import { Navigate } from 'react-router-dom';

// Panel kullanıcıları için route koruması
const PrivateRoute = ({ children }) => {
  // Panel kullanıcısı token'ını kontrol et
  const panelUserToken = localStorage.getItem('userToken');
  const panelUserData = localStorage.getItem('userData');
  
  // Form kullanıcısı giriş yapmışsa panel sayfalarına erişimi engelle
  const formUserToken = localStorage.getItem('formUserToken');
  const formUserData = localStorage.getItem('formUserData');
  
  if (formUserToken && formUserData) {
    try {
      const parsedUserData = JSON.parse(formUserData);
      if (parsedUserData && parsedUserData.id) {
        // Form kullanıcısı giriş yapmışsa user-dashboard'a yönlendir
        return <Navigate to="/user-dashboard" />;
      }
    } catch (error) {
      console.error('Error parsing stored form user data:', error);
    }
  }
  
  // Panel kullanıcısı giriş yapmışsa erişim ver
  if (panelUserToken && panelUserData) {
    return children;
  }
  
  // Hiçbir kullanıcı giriş yapmamışsa login sayfasına yönlendir
  return <Navigate to="/login" />;
};

// Form kullanıcıları için route koruması
const FormUserRoute = ({ children }) => {
  // Form kullanıcısı token'ını kontrol et
  const formUserToken = localStorage.getItem('formUserToken');
  const formUserData = localStorage.getItem('formUserData');
  
  // Panel kullanıcısı giriş yapmışsa form sayfalarına erişimi engelle
  const panelUserToken = localStorage.getItem('userToken');
  const panelUserData = localStorage.getItem('userData');
  
  if (panelUserToken && panelUserData) {
    try {
      const parsedUserData = JSON.parse(panelUserData);
      if (parsedUserData && parsedUserData.id && !parsedUserData.userType) {
        // Panel kullanıcısı giriş yapmışsa ana dashboard'a yönlendir
        return <Navigate to="/" />;
      }
    } catch (error) {
      console.error('Error parsing stored panel user data:', error);
    }
  }
  
  // Form kullanıcısı giriş yapmışsa erişim ver
  if (formUserToken && formUserData) {
    return children;
  }
  
  // Hiçbir kullanıcı giriş yapmamışsa user-login sayfasına yönlendir
  return <Navigate to="/user-login" />;
};

// Genel kullanıcı kontrolü (herhangi bir kullanıcı türü)
const AnyUserRoute = ({ children }) => {
  const panelUserToken = localStorage.getItem('userToken');
  const formUserToken = localStorage.getItem('formUserToken');
  
  if (panelUserToken || formUserToken) {
    return children;
  }
  
  return <Navigate to="/login" />;
};

export { PrivateRoute, FormUserRoute, AnyUserRoute };
export default PrivateRoute;